import { ListType } from 'types/selectbox';

// export const planTypeOption: ListType[] = [{ value: 1, label: 'PASS' }];

// export const countryOption: ListType[] = [
//   { value: 1, label: 'South Korea' },
//   { value: 2, label: 'Country 2' },
//   { value: 3, label: 'Country 3' },
//   { value: 4, label: 'Country 4' }
// ];

// export const currencyOption: ListType[] = [
//   { value: 1, label: 'KRW' },
//   { value: 2, label: 'USD' }
// ];

// export const perMinuteOption: ListType[] = [
//   { value: 1, label: '$13' },
//   { value: 2, label: '$15' },
//   { value: 3, label: '$17' },
//   { value: 4, label: '$19' }
// ];

// export const exchangeRates: { [key: number]: number } = {
//   1: 1, // USD
//   2: 1300, // KRW
//   3: 0.85 // EUR
// };

export const planTypeOption: ListType[] = [
  { value: 1, label: 'calculator.plan.pass' }
];

export const countryOption: ListType[] = [
  { value: 1, label: 'calculator.country.1' },
  { value: 2, label: 'calculator.country.2' },
  { value: 3, label: 'calculator.country.3' },
  { value: 4, label: 'calculator.country.4' }
];

export const currencyOption: ListType[] = [
  { value: 1, label: 'calculator.currency.1' },
  { value: 2, label: 'calculator.currency.2' }
];

export const perMinuteOption: ListType[] = [
  { value: 1, label: 'calculator.perMinute.1' },
  { value: 2, label: 'calculator.perMinute.2' },
  { value: 3, label: 'calculator.perMinute.3' },
  { value: 4, label: 'calculator.perMinute.4' }
];

export const exchangeRates: { [key: number]: number } = {
  1: 1,     // USD
  2: 1300,  // KRW
  3: 0.85   // EUR (참고: 현재 키 안 쓰는 곳이니 유지 가능)
};




